import React from "react";
const SummaryComment: React.VFC<{ data: any }> = ({ data }) => {
    // # レーダーチャートの下に「ワンポイント」の見出しと一緒にサマリーコメントが表示されている
    // - done 0点より大きい体質が1つ以上あり、かつすべての体質が30点未満の場合、共通テキストが表示される
    // - done すべての体質が0点の場合、共通テキストが表示される
    // - 30点以上の体質が以下の掛け合わせの場合、当該体質のテキストが表示される ☆
    //   - 気滞と血瘀が30点以上 → 気滞血瘀テキスト
    //   - 気虚と血虚が30点以上 → 気血両虚テキスト
    //   - 気虚と陽虚が30点以上 → 脾腎陽虚テキスト
    //   - 陰虚と陽虚が30点以上 → 陰陽両虚テキスト
    //   - 気滞と痰湿が30点以上 → 気滞痰湿テキスト
    //   - 気虚と痰湿が30点以上 → 気虚痰湿テキスト
    //   - 気虚と気滞が30点以上 → 気虚気滞テキスト
    //   - 血瘀と痰湿が30点以上 → 痰湿血瘀テキスト
    //   - 気虚と血瘀が30点以上 → 気虚血瘀テキスト
    //   - 血虚と血瘀が30点以上 → 血虚血瘀テキスト
    //   - 陰虚と血瘀が30点以上 → 陰虚血瘀テキスト
    //   - 血虚と陰虚が30点以上 → 血虚陰虚テキスト
    //   - 痰湿と陽虚が30点以上 → 痰湿陽虚テキスト
    //   - 陽虚と血瘀が30点以上 → 陽虚血瘀テキスト
    //   - 気滞と湿熱が30点以上 → 気滞湿熱テキスト
    // - 掛け合わせの体質が複数該当する場合、2つの体質の合計点が一番高いものが表示される
    //   - 掛け合わせの体質が複数該当し、一番高い2つの体質の合計点が同じ場合、下記の優先順位で表示される
    //     - 気滞血瘀
    //     - 気血両虚
    //     - 脾腎陽虚
    //     - 陰陽両虚
    //     - 気滞痰湿
    //     - 気虚痰湿
    //     - 気虚気滞
    //     - 痰湿血瘀
    //     - 気虚血瘀
    //     - 血虚血瘀
    //     - 陰虚血瘀
    //     - 血虚陰虚
    //     - 痰湿陽虚
    //     - 陽虚血瘀
    //     - 気滞湿熱
    // - 共通テキストのルールも、いずれの組み合わせも満たさない場合、セクションごと何も表示しない

    // ☆ : https://docs.google.com/spreadsheets/d/1d4AvBein1Pshd7lkSzZpAGClTg8g-qTfFamw3TVpjTo/edit#gid=188235134
    //   - 気滞, 血瘀 : ストレスなどで気のめぐりが悪い「気滞」状態が長引くと、血のめぐりにも影響を与え「血瘀」を引き起こしやすくなります。両方のスコアが高い場合は、「気滞」「血瘀」両方をバランスよく対策しましょう。
    //   - 気虚, 血虚 : 偏った食事を続けたり消化機能が低下すると、気が不足した状態の「気虚」と同時に、栄養の足りない「血虚」を併せ持つことがあります。両方のスコアが高い場合は、「気虚」「血虚」両方の対策をしましょう。
    //   - 気虚, 陽虚 : 身体を温める働きのある気が不足することにより、「気虚」から慢性的な冷え状態の「陽虚」へと進行していきます。両方のスコアが高い場合は、「陽虚」を優先的に捉えつつ両方の対策をしましょう。
    //   - 陰虚, 陽虚 : 腎の働きが低下することによって、腎が関係する「陰虚」「陽虚」両方の体質を併せ持ちます。両方のスコアが高い場合は体全体が衰弱傾向にあるため、「陰虚」「陽虚」両方の対策をしましょう。
    //   - 気滞, 痰湿 : 気のめぐりが悪い状態の「気滞」は水のめぐりにも影響を与え、体に不要な水分がたまった状態の「痰湿」を引き起こしやすくなります。両方のスコアが高い場合は、「気滞」「痰湿」両方をバランスよく対策しましょう。
    //   - 気虚, 痰湿 : 気が不足し消化機能が低下している「気虚」の影響で水のめぐりも悪くなり、余分な水が体内にたまった状態の「痰湿」を引き起こしやすくなります。両方のスコアが高い場合は、「気虚」「痰湿」両方をバランスよく対策しましょう。
    //   - 気虚, 気滞 : 気が不足した「気虚」状態にあると、気が自らめぐることができずに滞り「気滞」状態を引き起こすことがあります。両方のスコアが高い場合、「気虚」「気滞」両方をバランスよく対策しましょう。
    //   - 血瘀, 痰湿 : 水のめぐりが悪い「痰湿」状態によって、同時に流れる血のめぐりも悪くなり、血流が悪い状態の「血瘀」を引き起こしやすくなります。両方のスコアが高い場合は、「痰湿」「血瘀」両方をバランスよく対策しましょう。
    //   - 気虚, 血瘀 : 気には血行を促進する働きがあるため、気が不足した状態の「気虚」によって血流が悪い状態の「血瘀」も引き起こしやすくなります。両方のスコアが高い場合は、「気虚」「血瘀」両方をバランスよく対策しましょう。
    //   - 血虚, 血瘀 : 栄養やうるおいを含んだ血が不足した「血虚」状態では、乾燥によってめぐりが悪くなり、血流が悪い状態の「血瘀」も引き起こすことがあります。両方のスコアが高い場合は「血虚」「血瘀」両方をバランスよく対策しましょう。
    //   - 陰虚, 血瘀 : うるおいが不足した「陰虚」状態では乾燥によって血の流れも悪くなりやすく、血流が滞った「血瘀」を引き起こしやすくなります。両方のスコアが高い場合は、「陰虚」「血瘀」両方の対策をしましょう。
    //   - 血虚, 陰虚 : 栄養もうるおいも足りていない場合、「血虚」と「陰虚」を併せ持ちます。両方のスコアが高い場合は食事内容を見直しながら「血虚」「陰虚」両方の対策をしましょう。
    //   - 痰湿, 陽虚 : 余分な水分が体にたまる「痰湿」状態が続くと胃腸が弱り、体を温める力が不足した状態の「陽虚」を引き起こしやすくなります。両方のスコアが高い場合は、体を温めながら「痰湿」「陽虚」両方の対策をしましょう。
    //   - 陽虚, 血瘀 : 慢性的に冷え状態の「陽虚」になると、冷えによって血流が悪くなり「血瘀」も引き起こしやすくなります。両方のスコアが高い場合は、「陽虚」「血瘀」両方の対策をしましょう。
    //   - 気滞, 湿熱 : 気のめぐりが悪い「気滞」状態に加えて水分を摂りすぎると、体内に余分な水や熱がこもった「湿熱」を引き起こします。両方のスコアが高い場合は、「気滞」「湿熱」両方の対策をしましょう。

    const includesDoubleMatch = (
        targetKeys: Array<string>,
        firstString: string,
        secondString: string
    ): boolean =>
        targetKeys.includes(firstString) && targetKeys.includes(secondString);

    const handleText = (): string => {
        if (
            // すべての体質が0点の場合、共通テキストが表示される
            Object.values(data).reduce(
                // @ts-ignore
                (sum, element): number => sum + element,
                0
            ) === 0
        ) {
            return "今回の診断ではいずれの体質にも当てはまらず、健康的といえる結果となりました。この調子で自分にとってのベストな健康を続けていきましょう。";
        } else if (
            // 0点より大きい体質が1つ以上あり、かつすべての体質が30点未満の場合、共通テキストが表示される
            Object.values(data).every((e) => e < 30)
        ) {
            return "今回の診断では大きな偏りは見られません。スコアの高い体のバランスは常に変化しているため、日々自分の体と向き合いながら、自分にとってのベストな健康を見つけましょう。";
        } else {
            // 30点以上の体質が以下の掛け合わせの場合、当該体質のテキストが表示される ☆
            // 掛け合わせの体質が複数該当する場合、2つの体質の合計点が一番高いものが表示される
            // 掛け合わせの体質が複数該当し、一番高い2つの体質の合計点が同じ場合、下記の優先順位で表示される
            let hashArray: Array<{ totalScore: number; text: string }> = [];
            const targetKeys = Object.keys(data).filter((e) => data[e] >= 30);

            if (includesDoubleMatch(targetKeys, "気滞", "血瘀")) {
                hashArray.push({
                    totalScore: data["気滞"] + data["血瘀"],
                    text: "ストレスなどで気のめぐりが悪い「気滞」状態が長引くと、血のめぐりにも影響を与え「血瘀」を引き起こしやすくなります。両方のスコアが高い場合は、「気滞」「血瘀」両方をバランスよく対策しましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "気虚", "血虚")) {
                hashArray.push({
                    totalScore: data["気虚"] + data["血虚"],
                    text: "偏った食事を続けたり消化機能が低下すると、気が不足した状態の「気虚」と同時に、栄養の足りない「血虚」を併せ持つことがあります。両方のスコアが高い場合は、「気虚」「血虚」両方の対策をしましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "気虚", "陽虚")) {
                hashArray.push({
                    totalScore: data["気虚"] + data["陽虚"],
                    text: "身体を温める働きのある気が不足することにより、「気虚」から慢性的な冷え状態の「陽虚」へと進行していきます。両方のスコアが高い場合は、「陽虚」を優先的に捉えつつ両方の対策をしましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "陰虚", "陽虚")) {
                hashArray.push({
                    totalScore: data["陰虚"] + data["陽虚"],
                    text: "腎の働きが低下することによって、腎が関係する「陰虚」「陽虚」両方の体質を併せ持ちます。両方のスコアが高い場合は体全体が衰弱傾向にあるため、「陰虚」「陽虚」両方の対策をしましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "気滞", "痰湿")) {
                hashArray.push({
                    totalScore: data["気滞"] + data["痰湿"],
                    text: "気のめぐりが悪い状態の「気滞」は水のめぐりにも影響を与え、体に不要な水分がたまった状態の「痰湿」を引き起こしやすくなります。両方のスコアが高い場合は、「気滞」「痰湿」両方をバランスよく対策しましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "気虚", "痰湿")) {
                hashArray.push({
                    totalScore: data["気虚"] + data["痰湿"],
                    text: "気が不足し消化機能が低下している「気虚」の影響で水のめぐりも悪くなり、余分な水が体内にたまった状態の「痰湿」を引き起こしやすくなります。両方のスコアが高い場合は、「気虚」「痰湿」両方をバランスよく対策しましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "気虚", "気滞")) {
                hashArray.push({
                    totalScore: data["気虚"] + data["気滞"],
                    text: "気が不足した「気虚」状態にあると、気が自らめぐることができずに滞り「気滞」状態を引き起こすことがあります。両方のスコアが高い場合、「気虚」「気滞」両方をバランスよく対策しましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "血瘀", "痰湿")) {
                hashArray.push({
                    totalScore: data["血瘀"] + data["痰湿"],
                    text: "水のめぐりが悪い「痰湿」状態によって、同時に流れる血のめぐりも悪くなり、血流が悪い状態の「血瘀」を引き起こしやすくなります。両方のスコアが高い場合は、「痰湿」「血瘀」両方をバランスよく対策しましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "気虚", "血瘀")) {
                hashArray.push({
                    totalScore: data["気虚"] + data["血瘀"],
                    text: "気には血行を促進する働きがあるため、気が不足した状態の「気虚」によって血流が悪い状態の「血瘀」も引き起こしやすくなります。両方のスコアが高い場合は、「気虚」「血瘀」両方をバランスよく対策しましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "血虚", "血瘀")) {
                hashArray.push({
                    totalScore: data["血虚"] + data["血瘀"],
                    text: "栄養やうるおいを含んだ血が不足した「血虚」状態では、乾燥によってめぐりが悪くなり、血流が悪い状態の「血瘀」も引き起こすことがあります。両方のスコアが高い場合は「血虚」「血瘀」両方をバランスよく対策しましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "陰虚", "血瘀")) {
                hashArray.push({
                    totalScore: data["陰虚"] + data["血瘀"],
                    text: "うるおいが不足した「陰虚」状態では乾燥によって血の流れも悪くなりやすく、血流が滞った「血瘀」を引き起こしやすくなります。両方のスコアが高い場合は、「陰虚」「血瘀」両方の対策をしましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "血虚", "陰虚")) {
                hashArray.push({
                    totalScore: data["血虚"] + data["陰虚"],
                    text: "栄養もうるおいも足りていない場合、「血虚」と「陰虚」を併せ持ちます。両方のスコアが高い場合は食事内容を見直しながら「血虚」「陰虚」両方の対策をしましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "痰湿", "陽虚")) {
                hashArray.push({
                    totalScore: data["痰湿"] + data["陽虚"],
                    text: "余分な水分が体にたまる「痰湿」状態が続くと胃腸が弱り、体を温める力が不足した状態の「陽虚」を引き起こしやすくなります。両方のスコアが高い場合は、体を温めながら「痰湿」「陽虚」両方の対策をしましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "陽虚", "血瘀")) {
                hashArray.push({
                    totalScore: data["陽虚"] + data["血瘀"],
                    text: "慢性的に冷え状態の「陽虚」になると、冷えによって血流が悪くなり「血瘀」も引き起こしやすくなります。両方のスコアが高い場合は、「陽虚」「血瘀」両方の対策をしましょう。",
                });
            }
            if (includesDoubleMatch(targetKeys, "気滞", "湿熱")) {
                hashArray.push({
                    totalScore: data["気滞"] + data["湿熱"],
                    text: "気のめぐりが悪い「気滞」状態に加えて水分を摂りすぎると、体内に余分な水や熱がこもった「湿熱」を引き起こします。両方のスコアが高い場合は、「気滞」「湿熱」両方の対策をしましょう。",
                });
            }

            const maxTotalScore = Math.max.apply(
                Math,
                hashArray.map((v) => v.totalScore)
            );

            return hashArray
                .filter((v) => v.totalScore == maxTotalScore)
                .map((v) => v["text"])
                .join("\n\n");
        }

        return "";
    };

    return (
        <div
            className="tracking-widest leading-10 m-10 md:mt-4 text-justify md:w-1/2 order-2 md:order-1"
            style={{ whiteSpace: "pre-wrap" }}
        >
            {handleText()}
        </div>
    );
};

export default SummaryComment;
